var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJapan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 75C58.9607 75 75.75 58.2107 75.75 37.5C75.75 16.7893 58.9607 0 38.25 0C17.5393 0 0.75 16.7893 0.75 37.5C0.75 58.2107 17.5393 75 38.25 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2501 53.8044C47.2547 53.8044 54.5544 46.5047 54.5544 37.5001C54.5544 28.4955 47.2547 21.1958 38.2501 21.1958C29.2455 21.1958 21.9458 28.4955 21.9458 37.5001C21.9458 46.5047 29.2455 53.8044 38.2501 53.8044Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJapan);
export default __webpack_public_path__ + "static/media/flagJapan.8d2a9a46863f7c57469e69bc532dc14b.svg";
export { ForwardRef as ReactComponent };